import React, { useState, useEffect, useRef, useMemo } from 'react';
import "./employment.css";
import Carousel from 'react-bootstrap/Carousel';
import 'react-multi-carousel/lib/styles.css';
import { Col, Form } from 'react-bootstrap';
import SecondaryBanner from '../banner/secondary-banner';
import { getGender, getIntroduction, getCreateHire } from '../../utils/api'
import { from } from 'jalali-moment';
import Loader from '../loader/loader'
import { Toast } from 'primereact/toast';
import moment from 'jalali-moment';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import LoaderPage from '../../components/loader/dotloader'
import Select, { components } from 'react-select';
import { Sidebar } from 'primereact/sidebar';
import { isMobile } from 'react-device-detect';
import ArrowDown from '../../assets/icons/arrow-down.svg'
import useToastNotification from '../../hooks/useToastNotification';

const AboutUs = () => {
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const [foundUsList, setFoundUsList] = useState([])
  const [genderList, setGenderList] = useState([])
  const [validated, setValidated] = useState(false);
  const [visibleSubject, setVisibleSubject] = useState(false);
  const [visibleGender, setVisibleGender] = useState(false);

  //parameter
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [genderId, setGenderId] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [mobile, setMobile] = useState('')
  const [email, setEmail] = useState('')
  const [province, setProvince] = useState('')
  const [city, setCity] = useState('')
  const [address, setAddress] = useState('')
  const [foundUsId, setFoundUsId] = useState('')
  const [description, setDecription] = useState('')
  const [birthDate, setBirthDay] = useState('')
  const [isFoundUsInvalid, setIsFoundUsInvalid] = useState(false);
  const [isGenderInvalid, setIsGenderInvalid] = useState(false);
  const { showError, showSuccess } = useToastNotification();



  //convert to persianDate
  const convertDateToPersian = (date) => {
    if (!date) return '-';
    return moment(date).locale("fa").format("YYYY/MM/DD");
  };
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"]
  // Fetch department
  useEffect(() => {
    const fetchFoundUs = async () => {
      setLoadingPage(true)
      try {
        const pay = { pageSize: 0, pageIndex: 0 };
        const res = await getIntroduction(pay);
        if (res.data.isSuccess) {
          const items = res.data.data.items;
          setFoundUsList(items);
          setLoadingPage(false)
        }

      } catch (error) {
        setLoadingPage(false)

        console.error('Error fetching foundUs:', error);
      }
    };
    fetchFoundUs();
  }, []);

  // Fetch subject
  useEffect(() => {
    // const fetchGender = async () => {
    //   try {
    //     const pay = { pageSize: 0, pageIndex: 0 };
    //     const res = await getGender(pay);
    //     const items = res.data.data.items;
    //     setGenderList(items);
    //   } catch (error) {
    //     console.error('Error fetching gender:', error);
    //   }
    // };
    // fetchGender();
    let items = [{
      id: '1',
      title: 'مرد'

    }, {
      id: '2',
      title: 'زن'
    },
    {
      id: '0',
      title: 'سایر'
    }]
    setGenderList(items)
  }, []);
  const cleareData = () => {
    setFirstName('')
    setLastName('')
    setGenderId('')
    setBirthDay('')
    setPhoneNumber('')
    setMobile('')
    setEmail('')
    setProvince('')
    setCity('')
    setAddress('')
    setFoundUsId('')
    setDecription('')
  }
  const createEployment = async (e) => {
    e.preventDefault();
    if (!foundUsId) {
      setIsFoundUsInvalid(true);
    } else {
      setIsFoundUsInvalid(false);
      // ارسال فرم
    }
    if (!genderId) {
      setIsGenderInvalid(true);
    } else {
      setIsGenderInvalid(false);
      // ارسال فرم
    }
    const form = e.currentTarget;
    if (form.checkValidity() === true) {

      if (
        mobile.length != 11 &&
        !mobile.startsWith('09')
      ) {
        showError({text : 'لطفا شماره موبایل را به صورت صحیح وارد کنید'})
        return
      }
      setLoading(true)
      try {
        const gregorianBirthDate = birthDate
          ? moment.from(birthDate, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
          : null;
        let pay = {
          firstName: firstName,
          lastName: lastName,
          birthDate: birthDate,
          phoneNumber: phoneNumber,
          mobile: mobile,
          email: email,
          city: city,
          province: province,
          address: address,
          description: description,
          genderId: typeof genderId === 'object' && Object.keys(genderId).length > 0 ? genderId.id : genderId,
          introductionId: typeof foundUsId === 'object' && Object.keys(foundUsId).length > 0 ? foundUsId.id : foundUsId,
        }
        let res = await getCreateHire(pay)
        if (res.data.isSuccess) {
          setLoading(false)

          let message = {
            text: res.data.message
          }
          showSuccess(message)
          cleareData()
          setValidated(false)
          return

        } else {
          setLoading(false)
          let message = {
            text: res.data.message
          }
          showSuccess(message)
          // window.location.href = `/sign-up?mobile=${mobile}`
        }


      } catch (error) {
        setLoading(false)
        let message = {
          text: 'خطا در ارتباط با سرور'
        }
        showError(message)
      }

    }
    setValidated(true);
  }



  const customSelectStyles = {
    option: (provided) => ({
      ...provided,
      fontSize: "14px", // Customize font size here
      padding: "10px",
      fontWeight: '400' // Optional: Adjust padding for a better look
    }),
    control: (provided) => ({
      ...provided,
      fontSize: "14px", // Change font size for the selected option box
      fontWeight: '400'
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "14px", // Change font size for the currently selected value
      fontWeight: '400'
    }),
  };
  const CustomDropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.8527 9.64582C18.0484 9.84073 18.0489 10.1573 17.854 10.3529L12.389 15.8374C12.1741 16.0531 11.8248 16.0531 11.6098 15.8374L6.14484 10.3529C5.94993 10.1573 5.95049 9.84073 6.1461 9.64582C6.34171 9.4509 6.65829 9.45147 6.85321 9.64708L11.9994 14.8117L17.1456 9.64708C17.3406 9.45147 17.6571 9.4509 17.8527 9.64582Z" fill="#000" />
        </svg>

      </components.DropdownIndicator>
    );
  };
  const handleSelectChange = (selected) => {
    setGenderId(selected ? selected.value : ""); // تنظیم مقدار `text` با انتخاب یا حذف مقدار
    setIsGenderInvalid(!selected);
  };

  const optionsGender = genderList.map((text) => ({ value: text.id, label: text.title }));
  const handleSelectFoundUsChange = (selected) => {
    setFoundUsId(selected.value); // تنظیم مقدار `text` با انتخاب یا حذف مقدار
    setIsFoundUsInvalid(!selected); // اگر گزینه‌ای انتخاب نشود، خطا را فعال می‌کند

  };
  const optionsFoundUs = foundUsList.map((text) => ({ value: text.id, label: text.title }));

  const subjectTitle = useMemo(() => {
    try {
      if (foundUsId && foundUsList) {
        return foundUsList.find(item => item.id === foundUsId).title;
      }
      else {
        return '';
      }
    } catch (error) {

    }
  }, [foundUsId]);
  const GenderTitle = useMemo(() => {
    try {
      if (genderId && genderList) {
        return genderList.find(item => item.id === genderId).title;
      }
      else {
        return '';
      }
    } catch (error) {

    }
  }, [genderId]);
  return (
    <div>
      {loadingPage && <LoaderPage isLoading={loadingPage} />}

      <Toast ref={toast} />
      {/* <div>
        <SecondaryBanner slug='employment1' />
      </div> */}
      <div className='box-shadow'>

      </div>
      <section className='mt-5 container '>
        <h1 className='text-2xl font-bold leading-10 w-fit' style={{ borderBottom: '2px solid #00A14B' }}>استخدام و همکاری</h1>
        <div className='more-info mt-5 px-5 contact-us mx-0 bg-[#d1e6d2] flex-mob-col  rounded-[42px] d-flex align-items-center justify-content-between gap-5'>
          <Form className=' mx-auto' noValidate validated={validated} onSubmit={(e) => createEployment(e)}>
            <div className="text-sm font-bold mt-4 gy-3 row">
              <Form.Group className="col-md-4 col-lg-4 col-12">
                <Form.Label>نام<span className='text-[red]'> * </span></Form.Label>

                <Form.Control required value={firstName} onChange={(e) => setFirstName(e.target.value)} type="text" />
                <Form.Control.Feedback type="invalid">
                  نام را وارد کنید.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="col-md-4 col-lg-4 col-12">
                <Form.Label>نام خانوادگی<span className='text-[red]'> * </span></Form.Label>
                <Form.Control required value={lastName} onChange={(e) => setLastName(e.target.value)} type="text" />
                <Form.Control.Feedback type="invalid">
                  نام خانوادگی را وارد کنید.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="col-md-4 col-lg-4 col-12">
                <Form.Label>جنسیت<span className='text-[red]'> * </span></Form.Label>
                <div className='web'>
                  <Select
                    options={optionsGender}
                    value={genderId ? optionsGender.find((option) => option.id === genderId) : null}
                    onChange={handleSelectChange}
                    styles={customSelectStyles}
                    placeholder=""
                    className={isGenderInvalid ? 'is-invalid' : ''} // اضافه کردن کلاس برای نمایش خطا
                    components={{ DropdownIndicator: CustomDropdownIndicator }}
                  />
                  {isGenderInvalid && (
                    <Form.Control.Feedback type="invalid">
                      جنسیت را انتخاب کنید.
                    </Form.Control.Feedback>
                  )}

                </div>
                <div className='mobile'>

                  <div className='input-icon '>
                    <Form.Control value={genderId}
                      required
                      onClick={(e) => {
                        e.preventDefault(); // جلوگیری از باز شدن لیست
                        setVisibleGender(true); // نمایش Sidebar
                      }}
                      readOnly />
                    <img src={ArrowDown} alt="" />
                  </div>
                  <Form.Control.Feedback type="invalid">
                    جنسیت را انتخاب کنید.
                  </Form.Control.Feedback>
                </div>
                <Sidebar
                  header="جنسیت"
                  visible={visibleGender}
                  position="bottom"
                  onHide={() => setVisibleGender(false)}
                >
                  <div className="prepared-text-options">
                    {genderList.map((item, index) => (
                      <div
                        key={index}
                        className={`prepared-text-item ${genderId === item.id ? 'selected' : ''}`}
                        onClick={() => {
                          setGenderId(item.id);
                          isMobile === true && setVisibleGender(false); // Close sidebar on selection
                        }}
                        style={{
                          padding: '10px',
                          borderBottom: '1px solid #eee',
                          cursor: 'pointer',
                        }}
                      >
                        {item.title}
                      </div>
                    ))}
                  </div>
                </Sidebar>


              </Form.Group>
              <Form.Group className="col-md-4 col-lg-4 col-12">
                <Form.Label>تاریخ تولد<span className='text-[red]'> * </span></Form.Label>
                <Form.Group >
                  <DatePicker
                    required
                    weekDays={weekDays}
                    value={birthDate}
                    onChange={(date) => setBirthDay(convertDateToPersian(date.toDate()))}
                    calendar={persian}
                    locale={persian_fa}
                  />
                  <Form.Control.Feedback type="invalid">
                    تاریخ تولد را وارد کنید
                  </Form.Control.Feedback>
                </Form.Group>
              </Form.Group>
              <Form.Group className="col-md-4 col-lg-4 col-12">
                <Form.Label>شماره تلفن ثابت<span className='text-[red]'> * </span></Form.Label>
                <Form.Control required value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} type="number" />
                <Form.Control.Feedback type="invalid">
                  شماره تلفن ثابت را وارد کنید.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="col-md-4 col-lg-4 col-12">
                <Form.Label>شماره موبایل<span className='text-[red]'> * </span></Form.Label>
                <Form.Control required value={mobile} onChange={(e) => setMobile(e.target.value)} type="number" />
                <Form.Control.Feedback type="invalid">
                  شماره موبایل  را وارد کنید.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="col-md-4 col-lg-4 col-12">
                <Form.Label>ایمیل <span className='text-[red]'> * </span></Form.Label>
                <Form.Control required value={email} onChange={(e) => setEmail(e.target.value)} type="email" />
                <Form.Control.Feedback type="invalid">
                  ایمیل را صحیح وارد کنید.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="col-md-4 col-lg-4 col-12">
                <Form.Label>استان<span className='text-[red]'> * </span></Form.Label>
                <Form.Control required value={province} onChange={(e) => setProvince(e.target.value)} type="text" />
                <Form.Control.Feedback type="invalid">
                  استان را وارد کنید.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="col-md-4 col-lg-4 col-12">
                <Form.Label>شهر<span className='text-[red]'> * </span></Form.Label>
                <Form.Control required value={city} onChange={(e) => setCity(e.target.value)} type="text" />
                <Form.Control.Feedback type="invalid">
                  شهر را وارد کنید.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className=" col-12">
                <Form.Label>آدرس<span className='text-[red]'> * </span></Form.Label>
                <Form.Control required value={address} onChange={(e) => setAddress(e.target.value)} type="text" as="textarea" rows={1} />
                <Form.Control.Feedback type="invalid">
                  آدرس را وارد کنید.
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="col-md-4 col-lg-4 col-12">
                <Form.Label>نحوه آشنایی<span className='text-[red]'> * </span></Form.Label>

                <div className='web'>
                  <Select
                    options={optionsFoundUs}
                    value={foundUsId ? optionsFoundUs.find((option) => option.id === foundUsId) : null}
                    onChange={handleSelectFoundUsChange}
                    styles={customSelectStyles}
                    placeholder=""
                    className={isFoundUsInvalid ? 'is-invalid' : ''} // اضافه کردن کلاس برای نمایش خطا
                    components={{ DropdownIndicator: CustomDropdownIndicator }}
                  />
                  {isFoundUsInvalid && (
                    <Form.Control.Feedback type="invalid">
                      نحوه آشنایی را انتخاب کنید.
                    </Form.Control.Feedback>
                  )}
                </div>
                <div className='mobile'>

                  <div className='input-icon '>
                    <Form.Control value={subjectTitle}
                      required
                      onClick={(e) => {
                        e.preventDefault(); // جلوگیری از باز شدن لیست
                        setVisibleSubject(true); // نمایش Sidebar
                      }}
                      readOnly />
                    <img src={ArrowDown} alt="" />
                  </div>
                  <Form.Control.Feedback type="invalid">
                    نحوه آشنایی را انتخاب کنید.
                  </Form.Control.Feedback>
                </div>
                <Sidebar
                  header="نحوه آشنایی"
                  visible={visibleSubject}
                  position="bottom"
                  onHide={() => setVisibleSubject(false)}
                >
                  <div className="prepared-text-options">
                    {foundUsList.map((item, index) => (
                      <div
                        key={index}
                        className={`prepared-text-item ${foundUsId === item.id ? 'selected' : ''}`}
                        onClick={() => {
                          setFoundUsId(item.id);
                          isMobile === true && setVisibleSubject(false); // Close sidebar on selection
                        }}
                        style={{
                          padding: '10px',
                          borderBottom: '1px solid #eee',
                          cursor: 'pointer',
                        }}
                      >
                        {item.title}
                      </div>
                    ))}
                  </div>
                </Sidebar>


              </Form.Group>
              <Form.Group className="col-md-8 col-lg-8 col-12">
                <Form.Label>توضیحات</Form.Label>
                <Form.Control value={description} onChange={(e) => setDecription(e.target.value)} type="text" as="textarea" rows={1} />

              </Form.Group>
            </div>
            <button disabled={loading} className="btn btn-primary w-1/4 mt-4 max-sm:!w-full d-flex align-items-center gap-2" type="submit" style={{ float: 'inline-end' }}>ثبت {loading && <Loader />}</button>
          </Form>
        </div>
      </section>
    </div>
  );
}

export default AboutUs;
